import {getId} from 'apis/model/base'
import classNames from 'classnames'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useState} from 'react'
import {BiTrash} from 'react-icons/bi'
import {Link} from 'react-router-dom'
import {CourseActionTypes, enrollment_status_options,} from 'views/AppLocals/Course'
import {useCourse} from 'views/AppLocals/Course/useCourse'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {NullAsDefault, renderElse, renderIf, renderIfElse} from 'views/Shared'
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {Avatar, message} from "antd";
import copyToClipboard from "copy-to-clipboard";
import {IoCopyOutline} from "react-icons/io5";
import {FaUserGraduate} from "react-icons/fa6";
import {GoDotFill} from "react-icons/go";
import {IdentifierTypes} from "../../../AppLocals/appFieldTypes";
import getAliasName from "../../../../helpers/getAliasName";
import {BsInfoCircleFill} from "react-icons/bs";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";

const WrapperClassStudent = ({item, index, children}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {
        course,
        student,
        user,
        patron_saint_name,
        fullname,
        identifier_code,
        identifier_type,
        is_self_reg = 1,

    } = item ?? {}

    return (
        <div key={index} className="p-3 flex flex-col border border-color-50 shadow-md rounded-lg hover:scale-2xs custom-item-render relative">
            <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                <Avatar
                    size={30}
                    src={user?.avatar}
                    icon={<FaUserGraduate size={14} className="text-color-500"/>}
                    className="flex flex-center background-200"
                />
                {renderIfElse(
                    _.some([user]),
                    <div className="flex flex-col flex-1 mr-6 md:mr-0">
                        {renderIfElse(
                            !is_self_reg,
                            <div className="space-x-1 leading-snug">
                                <span className="text-color-300 italic">{t('user')}</span>
                                <Link to={getLinkToDetail(user) || "#"}
                                      className="no-underline font-bold text-color-000">
                                    {renderIf(
                                        getAliasName(user, 'patron_saint'),
                                        <span
                                            className="mr-1 font-medium text-color-300 italic">{getAliasName(user, 'patron_saint')}</span>
                                    )}
                                    {getTitle(user)}
                                </Link>
                                <span className="text-color-300 italic lowercase">
                                    {t('registered for the course')}
                                </span>
                                <Link to={getLinkToDetail(course)}
                                      className="font-semibold text-green-600 italic no-underline">
                                    {getTitle(course)}
                                </Link>
                                <span className="text-color-300 italic lowercase">
                                    {t('for student')}
                                </span>
                                <span className="no-underline font-bold text-color-000">
                                    {renderIf(
                                        getAliasName(item, 'patron_saint'),
                                        <span className="mr-1 font-medium text-color-300 italic">
                                            {getAliasName(item, 'patron_saint')}
                                        </span>
                                    )}
                                    {fullname}
                                </span>
                            </div>,
                            <div className="space-x-1 text-base leading-snug">
                                <Link to={getLinkToDetail(user) || "#"}
                                      className="no-underline font-bold text-color-000">
                                    {renderIf(
                                        getAliasName(item, 'patron_saint'),
                                        <span
                                            className="mr-1 font-medium text-color-300 italic">{getAliasName(item, 'patron_saint')}</span>
                                    )}
                                    {fullname}
                                </Link>
                            </div>
                        )}
                        {renderIf(
                            student && is_self_reg,
                            <div className="space-x-1 text-color-500 text-xs italic">
                                <span className="whitespace-no-wrap">
                                    {isSm ? '#' : `${t('student code')} : `}
                                </span>
                                <span
                                    onClick={() => {
                                        copyToClipboard(student?.student_idcode)
                                        message.info(t('copied'))
                                    }}
                                    className="font-semibold text-blue-500 hover:text-blue-700 italic cursor-pointer">
                                    {student?.student_idcode}
                                    <IoCopyOutline size={12} className="ml-1"/>
                                </span>
                            </div>
                        )}
                    </div>,
                    <div className="flex flex-col flex-1">
                        <div className="space-x-1 text-base leading-snug">
                            {renderIf(
                                getAliasName(item, 'patron_saint'),
                                <span className="mr-1 font-medium text-color-300 italic">
                                    {getAliasName(item, 'patron_saint')}
                                </span>
                            )}
                            <span className="font-bold text-color-000 leading-snug">
                                {fullname}
                            </span>
                        </div>
                        <ItemInformation
                            label={t(_.find(IdentifierTypes, {value: identifier_type})?.label)}
                            value={identifier_code}
                            className="text-xs italic"
                        />
                    </div>
                )}
            </div>
            {children}
        </div>
    )
}

export const CourseEnrollment = ({item, onRefresh = NullAsDefault}) => {
    const t = useTranslate()
    const id = getId(item)
    const [current, setCurrent] = useState('0')

    const {onDeleteEnrollment = NullAsDefault} = useCourse({
        onEnrollmentDeleted: onRefresh,
    })

    const handleAction = (action, params) => {
        switch (action) {
            case CourseActionTypes.ENROLLMENT_DELETE:
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete enrollment',
                    message: 'are you sure you want to delete this enrollment',
                    onOk: () => {
                        onDeleteEnrollment({}, {id: getId(params)})
                    },
                })
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CourseActionTypes.ENROLLMENT_DELETE,
                    },
                ],
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    return renderMyEnrollment({renderContextMenu,})(item, id)
}

export const renderMyEnrollment = ({renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {
        course,
        status, notes,
        registered_subjects = [],
        is_self_reg = 1,
        contact_phone,
        contact_email,
        fullname,
        patron_saint_name,
        enrollment_date,
    } = item ?? {}
    const status_options = Object.values(enrollment_status_options)
    const current_status = _.find(status_options, {value: status}) ?? {}

    return (
        <div key={index} className="py-2 flex flex-col gap-1 rounded-lg custom-item-render custom-render-border relative">
            {renderIfElse(
                is_self_reg,
                <div className="flex flex-col gap-1 mr-8">
                    <div className="space-x-2 text-sm italic">
                        <span className="text-color-200 italic">
                          {t('you have successfully registered for the course')}
                        </span>
                        <Link
                            to={getLinkToDetail(course)}
                            className="font-bold text-color-000 no-underline">
                            {course?.title}
                        </Link>
                    </div>
                    <div className="flex-1 space-x-1 text-xs">
                        <GoDotFill size={10} className="text-color-400"/>
                        <span className="text-color-500 whitespace-no-wrap italic">
                            {`${t('subjects registered')} :`}
                        </span>
                        {renderIfElse(
                            registered_subjects?.length > 0,
                            registered_subjects?.map((e, i) => (
                                <span key={i} className="font-semibold text-color-000">
                                    {getTitle(e)} {i < registered_subjects?.length - 1 && ', '}
                                </span>
                            )),
                            <span className="font-semibold text-color-100">
                                {t('not update')}
                            </span>
                        )}
                    </div>
                    <ItemInformation
                        showIcon={true}
                        label="enrollment date"
                        value={formatSimplifyDate(enrollment_date) || t('not update')}
                        className="text-xs italic tracking-wide"
                    />
                    {renderIf(
                        notes,
                        <span className="text-xs text-color-400 italic">{notes}</span>
                    )}
                </div>,
                <div className="flex flex-col gap-1 mr-8">
                    <div className="space-x-2 text-sm">
                        <span className="text-color-200 italic">
                          {t('you have successfully registered for the course')}
                        </span>
                        <Link
                            to={getLinkToDetail(course)}
                            className="font-semibold text-green-600 italic no-underline">
                            {course?.title}
                        </Link>
                        <span className="text-color-200 italic lowercase">
                            {t('for student')}
                        </span>
                    </div>
                    <div className="ml-2 md:ml-3 mt-1 flex flex-col gap-1">
                        <div className="flex items-center gap-2">
                            <BsInfoCircleFill size={14} className="text-blue-300"/>
                            <span className="font-bold text-sm text-blue-600 uppercase tracking-wide">
                                {t('student information')}
                            </span>
                            <div className="flex-1 line-border-opacity text-blue-200"/>
                        </div>
                        <div className="ml-2 md:ml-3 flex flex-col gap-1">
                            <ItemInformation
                                primary={true}
                                showIcon={true}
                                label="full name"
                                value={`${patron_saint_name || ''} ${fullname}`}
                                className="text-sm"
                            />
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst="contact"
                                valueFirst={contact_phone}
                                labelSecond={contact_email ? ' - ' : ''}
                                valueSecond={contact_email}
                                className="text-xs italic"
                            />
                            <div className="flex-1 space-x-1 text-xs">
                                <GoDotFill size={10} className="text-color-400"/>
                                <span className="text-color-500 whitespace-no-wrap italic">
                                    {`${t('subjects registered')} :`}
                                </span>
                                {renderIfElse(
                                    registered_subjects?.length > 0,
                                    registered_subjects?.map((e, i) => (
                                        <span key={i} className="font-semibold text-color-000">
                                            {getTitle(e)} {i < registered_subjects?.length - 1 && ', '}
                                        </span>
                                    )),
                                    <span className="font-semibold text-color-300">
                                        {t('not update')}
                                    </span>
                                )}
                            </div>
                            <ItemInformation
                                showIcon={true}
                                label="enrollment date"
                                value={formatSimplifyDate(enrollment_date) || t('not update')}
                                className="text-xs italic tracking-wide"
                            />
                        </div>
                    </div>
                    {renderIf(
                        notes,
                        <span className="text-xs text-color-400 italic">{notes}</span>
                    )}
                </div>
            )}
            <div style={{position: 'absolute', bottom: 5, right: 5}}>
                <span
                    style={{fontSize: '0.65rem', height: 14}}
                    className={classNames('w-fit flex items-center gap-1 leading-tight', current_status?.className)}>
                    {renderElse(isSm, current_status?.icon)}
                    {renderIf(
                        _.isString(current_status?.label),
                        <span className="font-medium italic">
                            {t(current_status?.label)}
                        </span>
                    )}
                </span>
            </div>
            <div className="absolute top-5 right-0 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}

export const renderCourseEnrollment = ({renderActions = NullAsDefault, renderContextMenu = NullAsDefault, statusFilter} = {}) => (item, index) => {
    const t = useTranslate()
    const {
        student,
        user,
        status,
        course,
        contact_email,
        contact_phone,
        contact_address,
        date_of_birth,
        gender,
        registered_subjects = [],
        is_self_reg = 1,
        fullname,
        religious_order_name,
        patron_saint_name,
        ...rest
    } = item ?? {}

    const {isSm} = useContext(LayoutContext)
    const status_options = Object.values(enrollment_status_options)
    const current_status = _.find(status_options, {value: status}) ?? {}

    return (
        <WrapperClassStudent index={index} item={item}>
            {renderIfElse(
                is_self_reg,
                <div style={{marginLeft: '0.8rem'}} className="flex flex-col gap-1 relative">
                    <ItemInformation
                        showIcon={true}
                        className="text-sm"
                        label="enrolled in the course"
                        value={
                            <Link to={getLinkToDetail(course)} className="text-xs text-color-000 no-underline">
                                {getTitle(course)}
                            </Link>
                        }
                    />
                    {renderIfElse(
                        student,
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="contact"
                            valueFirst={student?.contact_phone}
                            labelSecond={student?.contact_email && " - " || ''}
                            valueSecond={student?.contact_email}
                            className="text-sm italic"
                        />,
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="contact"
                            valueFirst={contact_phone}
                            labelSecond={contact_email && " - " || ''}
                            valueSecond={contact_email}
                            className="text-sm italic"
                        />
                    )}
                    <div className="flex-1 space-x-1 text-sm">
                        <GoDotFill size={10} className="text-color-400"/>
                        <span className="text-color-400 whitespace-no-wrap italic">
                            {`${t('subjects registered')} :`}
                        </span>
                        {renderIfElse(
                            registered_subjects.length > 0,
                            registered_subjects.map((e, i) => (
                                <span key={i} className="font-semibold text-color-000">
                                {getTitle(e)} {i < registered_subjects.length - 1 && ', '}
                            </span>
                            )),
                            <span className="font-semibold text-color-300">
                            {t('not update')}
                        </span>
                        )}
                    </div>
                    <div style={{position: 'absolute', top: !isSm && 0, right: 5}}
                         className="flex items-center gap-2">
                        {renderIf(
                            !isSm && statusFilter === null,
                            <span
                                style={{fontSize: '0.65rem', height: 14}}
                                className={classNames('flex flex-center gap-1 leading-tight', current_status?.className)}>
                                {current_status?.icon}
                                <span className="font-medium italic">
                                    {t(current_status?.label)}
                                </span>
                            </span>
                        )}
                        {renderElse(isSm, renderActions(item))}
                    </div>
                </div>,
                <div style={{marginLeft: '0.65rem'}} className="mt-1 flex flex-col relative">
                    <div className="flex items-center gap-2">
                        <BsInfoCircleFill size={14} className="text-blue-300"/>
                        <span className="font-bold text-sm text-blue-600 uppercase tracking-wide">
                            {t('student information')}
                        </span>
                        <div className="flex-1 line-border-opacity text-blue-200"/>
                    </div>
                    <div className="ml-2 md:ml-3 flex flex-col gap-1">
                        <ItemInformation
                            primary={true}
                            showIcon={true}
                            label="full name"
                            value={`${patron_saint_name || ''} ${fullname}`}
                            className="text-sm"
                        />
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="contact"
                            valueFirst={contact_phone}
                            labelSecond={contact_email ? ' - ' : ''}
                            valueSecond={contact_email}
                            className="text-sm italic"
                        />
                        <div className="flex-1 space-x-1 text-sm">
                            <GoDotFill size={10} className="text-color-400"/>
                            <span className="text-color-400 whitespace-no-wrap italic">
                                {`${t('subjects registered')} :`}
                            </span>
                            {renderIfElse(
                                registered_subjects.length > 0,
                                registered_subjects.map((e, i) => (
                                    <span key={i} className="font-semibold text-color-000">
                                        {getTitle(e)} {i < registered_subjects.length - 1 && ', '}
                                    </span>
                                )),
                                <span className="font-semibold text-color-300">
                                    {t('not update')}
                                </span>
                            )}
                        </div>
                    </div>
                    <div style={{position: 'absolute', top: !isSm && 20, right: 5}}
                         className="flex items-center gap-2">
                        {renderIf(
                            !isSm && statusFilter === null,
                            <span
                                style={{fontSize: '0.65rem', height: 14}}
                                className={classNames('flex flex-center gap-1 leading-tight', current_status?.className)}>
                                {current_status?.icon}
                                <span className="font-medium italic">
                                    {t(current_status?.label)}
                                </span>
                            </span>
                        )}
                        {renderElse(isSm, renderActions(item))}
                    </div>
                </div>
            )}
            <div className="absolute top-5 right-0 flex gap-3 flex-row">
                <div className="contextIcon">
                    {renderContextMenu(item)}
                </div>
            </div>
        </WrapperClassStudent>
    )
}
